import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import dayjs, { Dayjs } from "utils/dayjs"

import { Guid, IApiLink, Lmid } from "@/types"
import RequestLocation, { IGetRequestLocationDto } from "./RequestLocation"
import { ShippingOrderDisplayStatus, ShippingOrderType } from "./ShippingOrder"

export enum ShippingMode {
    mobile = "mobile",
    web = "web",
}

export interface IGetShippingOrderOverviewItemDto {
    id: Guid
    reservationId: Guid
    number: string
    status: ShippingOrderDisplayStatus
    type: ShippingOrderType
    completeMode?: ShippingMode | null
    departureDate: string
    arrivalDate: string
    departureDateMin?: string | null
    arrivalDateMax?: string | null
    customerName: string
    customerNumber?: string | null
    nodeArticleId?: Guid | null
    mainAssetId: Guid
    assetCount: number
    departureLocations: IGetRequestLocationDto[]
    arrivalLocations: IGetRequestLocationDto[]
    responsibleWarehouseId?: Guid | null
    links: IApiLink[]
}

interface IShippingOrderOverviewItemParams {
    mainArticleDescription: string
    mainAssetLmid: Lmid
    mainArticleId: Guid
}

export default class ShippingOrderOverviewItem {
    id: Guid
    reservationId: Guid
    number: string
    status: ShippingOrderDisplayStatus
    type: ShippingOrderType
    completeMode?: ShippingMode
    departureDate: Dayjs
    arrivalDate: Dayjs
    departureDateMin?: Dayjs
    arrivalDateMax?: Dayjs
    customerName: string
    customerNumber?: string
    mainAssetId: Guid
    assetCount: number
    departureLocations: RequestLocation[]
    arrivalLocations: RequestLocation[]
    mainArticleDescription: string
    mainAssetLmid: Lmid
    responsibleWarehouseId?: Guid

    linkCreateShippingOrderCart?: IApiLink

    #mainArticleId: Guid
    #nodeArticleId?: Guid

    constructor(dto: IGetShippingOrderOverviewItemDto, params: IShippingOrderOverviewItemParams) {
        this.id = dto.id
        this.reservationId = dto.reservationId
        this.number = dto.number
        this.status = dto.status
        this.type = dto.type
        this.completeMode = dto.completeMode ?? undefined
        this.departureDate = dayjs.utc(dto.departureDate)
        this.arrivalDate = dayjs.utc(dto.arrivalDate)
        this.departureDateMin = dto.departureDateMin ? dayjs.utc(dto.departureDateMin) : undefined
        this.arrivalDateMax = dto.arrivalDateMax ? dayjs.utc(dto.arrivalDateMax) : undefined
        this.customerName = dto.customerName
        this.customerNumber = dto.customerNumber || undefined
        this.mainAssetId = dto.mainAssetId
        this.assetCount = dto.assetCount
        this.departureLocations = dto.departureLocations.map(rlDto => new RequestLocation(rlDto))
        this.arrivalLocations = dto.arrivalLocations.map(rlDto => new RequestLocation(rlDto))
        this.mainArticleDescription = params.mainArticleDescription
        this.mainAssetLmid = params.mainAssetLmid
        this.responsibleWarehouseId = dto.responsibleWarehouseId || undefined

        this.linkCreateShippingOrderCart = dto.links.find(link => link.entity === ApiLinkEntity.shippingOrderCart && link.rel === ApiLinkRel.new)

        this.#mainArticleId = params.mainArticleId
        this.#nodeArticleId = dto.nodeArticleId || undefined
    }

    get isMainArticleNode() {
        return this.#nodeArticleId === this.#mainArticleId
    }
}
